import type { ReactNode } from 'react';

/**
 * Root layout applied to every routed page (via `common/components/layout/
 * AppLayout`). Currently a pass-through — global chrome that must wrap ALL
 * routes (banners, portals, …) goes here.
 */
export default function RootLayout({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
